import { z } from 'zod';

export const TrackerEventSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('pageview'),
    url: z.string(),
    referrer: z.string().optional(),
    t: z.number(),
  }),
  z.object({
    type: z.literal('click'),
    x: z.number(),
    y: z.number(),
    selector: z.string(),
    text: z.string().max(80).optional(),
    t: z.number(),
  }),
  z.object({
    type: z.literal('scroll'),
    y: z.number(),
    pct: z.number().min(0).max(100),
    t: z.number(),
  }),
  z.object({
    type: z.literal('mouse_move'),
    x: z.number(),
    y: z.number(),
    t: z.number(),
  }),
  z.object({
    type: z.literal('error'),
    message: z.string(),
    stack: z.string().optional(),
    t: z.number(),
  }),
  z.object({
    type: z.literal('rrweb'),
    data: z.unknown(),
    t: z.number(),
  }),
]);

export type TrackerEvent = z.infer<typeof TrackerEventSchema>;

export const CollectPayloadSchema = z.object({
  site_id: z.string().regex(/^[A-Za-z0-9_-]{12}$/, 'invalid site_id format'),
  session_id: z.string().regex(/^[A-Za-z0-9_-]{16}$/, 'invalid session_id format'),
  visitor_id: z.string().regex(/^vis_[A-Za-z0-9_-]{17}$/, 'invalid visitor_id format'),
  url: z.string(),
  viewport: z.object({
    w: z.number().int().positive(),
    h: z.number().int().positive(),
  }),
  events: z.array(TrackerEventSchema).min(1).max(500),
});

export type CollectPayload = z.infer<typeof CollectPayloadSchema>;
